import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  colors,
  Container,
  Grid,
  Hidden,
  LinearProgress,
  makeStyles,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import BalanceCustRPTForm from "../balanceCustRPT-form";
import { useHistory } from "react-router-dom";

import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import {
  useStylesSpDial,
  useStylesUiElemment,
} from "../../St/Reports/UseStyle";
import moment from "moment";
import { insh as inshst } from "../../Context/InshSt";
import { SAdefaultValues } from "../balanceCustRPT-services";
import BalanceCustRPTTable from "../balanceCustRPT-table";
import { URL } from "../../api/customer";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import { Store, TableChart } from "@material-ui/icons";
import { balanceTypes } from "../balanceCustRPT-services";
import TotalsCard from "../TotalsCard";
import BalanceCutomerTable from "../balanceCustsTable";
import SelectTypesFilter from "../balanceCustRPT-typeFilter";
import { uri } from "../../help/Api";
import OrderCard from "../components/order-card";
import CustomerCard from "../components/customer-card";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import useFetchURL from "../../components/Hooks/useFetchURL";
import LoadingPage from "../../services/LoadingPage";
import useFormDataCRUD from "../../components/Hooks/useEDSCURD";
import { useAPI } from "../../api/useAPI";
import toast from "react-hot-toast";
import { inshs } from "../../Context/Local";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#ffffff",
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },

  headerTitle: {
    // backgroundColor: colors.red[30],
    textAlign: "center",
    fontSize: 20,
    width: "100%",
    fontWeight: "bold"
  },

  blCard: {
    backgroundColor: "#fff",
    borderColor: "#81007f",
  },
  root3: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: colors.red[300],
    direction: "rtl",
    marginTop: 5,
    padding: 5,
    // boxShadow:'box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;',
    boxShadow:
      "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;",
  },
}));

export default function OrderPage(props) {
  const { order, parms, fetchURL} = props;
  const { createFun } = useAPI("orders/changeStatues");
  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,
  } = useFormDataCRUD(
    createFun,
    () => { },
    () => { },
    undefined,
    { ...order },
    null,
    fetchURL,
    "edit"
  );
  let from_date = moment(new Date()).subtract().format("YYYY") + "-01-01";

  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();
  // const [data, setData] = useState([]);
  const handleUpdate = async (actionName) => {

    if(actionName == "invoiced")
      his.push({
        pathname: `/Invoces`,
        state: {...inshs.Sales.sal, 
          isOrder: true, 
          orderProceId: order.invoice_id, 
          orderId: order.id},
      
      });
      else{


    let model = {
      order: { ...order },
      parms: parms,
      actionName: actionName
    };
    await submit(model)
      .then((res) => {
        toast.success("تم تعديل status ");
      })
      .catch((err) => {
        console.log(err);
        toast.err("there is error");
      });
  }

  }

  const { t } = useTranslation(["forms"]);
  useEffect(() => {
    console.log(" the balance ", order);
  }, []);
  const his = useHistory();
  const toBack = () => {
    his.push({ pathname: "/" });
  };




  return (
    <div className={classes.root}>
      <Grid container item xs={12}>


      </Grid>
      <Typography component="div" style={{ direction: "rtl" }}>
        <Box display={"flex"} alignItems={"space-between"} gap={1} mt={1} mr={2}>
          <Box display={"flex"} alignItems={"space-between"} gap={1} mt={1}>
            {/* <Store color="action" style={{marginInline: 3}}/> */}
            <Typography variant="h6" className={classes.headerTitle}>

              Order Details
            </Typography>
            <Chip label={order.id} color="info" size="small" />
          </Box>
        </Box>
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingTop:"20px",
            marginBottom:"30px",
            // paddingTop: "0px",
            borderTopColor: colors.lightBlue[50],
            borderTopWidth: "5px",
            borderTopStyle: "solid",
          }}
        >

          <Grid container spacing={2}>
            <Grid item lg={8} sm={8} md={8} xs={12}>

              <OrderCard order={order} />
            </Grid>
            <Grid item lg={4} sm={4} md={4} xs={12} container spacing={2}>
              <Grid item xs={12}>
                {order?.status == 2 && 
                <Typography variant="h6" fontWeight="bold" style={{ direction: "rtl", color: colors.green[600] }}>
                        The order is Invoiced with invoice Id : {order?.invoice_id}                        
                    </Typography>
                }
                 {order?.status == -1 && 
                <Typography variant="h6" fontWeight="bold" style={{ direction: "rtl", color: colors.red[600] }}>
                        The order is Invoiced Canceled                         
                    </Typography>
                }
                {
                  (order.status == 0 || order.status == 1 ) && <Box display="flex" flexDirection="column" mb={2} mt={0}>
                  <Button
                    disabled={submitting}
                    variant="contained"
                    display="flex"
                    color="primary"
                    // startIcon={<ScannerIcon />}
                    size="large"
                    style={{ width: "100%" }}
                    className={[clasui.button]}
                  onClick={()=>{
                   order?.status == 0 ? handleUpdate("confirmed") : handleUpdate("invoiced")
                  }}
                  >
                    {order?.status == 0? t("Confirme Order"): t("Generate Invoice")}
                  </Button>
                
                  <Button
                    disabled={submitting}
                    variant="contained"
                    color="secondary"
                    // startIcon={<ScannerIcon />}
                    size="large"
                    style={{ backgroundColor: colors.red[500], width: "100%", marginTop: 2 }}
                    className={[clasui.button]}
                  onClick={()=>{
                    handleUpdate("canceled")
                  }}
                  >
                    {t("forms:cancel")}
                  </Button>
                </Box>
                }
              
                <CustomerCard name={order?.customer_name} contact={order?.customer_contact} />
              </Grid>
            </Grid>
          </Grid>
          {/* <BalanceCustRPTForm
            {...{
              AutoOptions,
              rptParams,
              setRptParams,
              onChangeData,
              onChangeAutoData,
              printHandle,
            }}
          /> */}

        </Container>
      </Typography >
    </div >
  );
}
